var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJazar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6567 13.5988C19.8458 12.5022 18.3566 11.9355 16.1025 11.8681C16.0496 11.8671 15.9976 11.8661 15.9447 11.8661H14.8321C14.7792 11.8661 14.7262 11.8661 14.6743 11.8681C14.3807 11.8773 14.0851 11.911 13.7954 11.9702C13.5368 12.0233 13.3061 12.1673 13.1473 12.3766L13.1323 12.396C12.7597 12.8963 12.6998 13.5304 12.9715 14.0899C13.2521 14.6689 13.8194 15.0283 14.4536 15.0283C14.5055 15.0283 14.5585 15.0263 14.6124 15.0211C14.6613 15.016 14.7103 15.014 14.7592 15.012C14.7842 15.012 14.8091 15.0109 14.8341 15.0109H15.9467C15.9717 15.0109 15.9966 15.0109 16.0196 15.012C16.7217 15.0334 17.3789 15.3744 17.8213 15.9493C18.2837 16.5497 18.4605 17.3246 18.3067 18.0741L16.7247 25.7749C16.5909 26.4243 16.0296 26.895 15.3904 26.895C14.7512 26.895 14.1889 26.4243 14.0561 25.7749C13.9662 25.3369 13.6137 24.9948 13.1802 24.9233C12.6888 24.8427 12.2084 24.908 11.774 25.1143C11.2806 25.3491 11.015 25.8933 11.1278 26.4386C11.3365 27.4606 11.8829 28.3847 12.6659 29.0412C13.4379 29.6855 14.4057 30.0398 15.3904 30.0398C16.3752 30.0398 17.3439 29.6845 18.115 29.0402C18.897 28.3857 19.4433 27.4617 19.653 26.4386L21.235 18.7357C21.4457 17.7106 21.8113 15.1569 20.6577 13.5978L20.6567 13.5988Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2864 2.78588V6.7006C12.2864 8.91629 14.0441 10.7123 16.2104 10.7123C16.2673 10.7123 16.3223 10.7113 16.3782 10.7082C16.3812 10.6521 16.3822 10.5949 16.3822 10.5387V6.62403C16.3822 4.40834 14.6254 2.6123 12.4582 2.6123C12.4012 2.6123 12.3463 2.61333 12.2904 2.61639C12.2874 2.67255 12.2864 2.72973 12.2864 2.78588Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.6826 9.37177V10.6991C18.6971 10.5296 20.2791 8.80406 20.2791 6.70172V5.37537C19.3263 5.45399 18.4694 5.88385 17.8322 6.53426C17.1221 7.26125 16.6836 8.26495 16.6836 9.37177H16.6826Z",
    fill: "#1D2939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJazar);
export default __webpack_public_path__ + "static/media/jazar.df7e9e9da1f87d44377a2eecddd743ec.svg";
export { ForwardRef as ReactComponent };